import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class AlarmService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"alarm")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByUser(idUser :String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"alarm/findByUser/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(alarm:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"alarm",alarm)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(alarm:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"alarm/"+alarm.idAlarm,alarm)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(id:number){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"alarm/"+id)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/alarm.service.ts